export default {
	game: {
		maintenance: 'Em Manutenção',
		maintenance_tip: 'Temporariamente indisponível',
		no_more_data: 'Sem mais dados',
		search_game_name: 'Buscar nome do jogo...',
		selected: 'Selecionado',
		type: 'Tipo',
		all_types: 'Todos os Tipos',
		secondary: 'Secundário',
		secondary_category: 'Categoria Secundária',
		no_related_games: 'Nenhum jogo relacionado encontrado',
		reset_all: 'Redefinir Tudo',
		end_of_list: 'Fim da Lista',
		game_details: 'Detalhes do Jogo',
		play: 'Jogar',
		bonus_cannot_wagered: 'Bônus não pode ser apostado',
		entering_game: 'Entrando no jogo, aguarde...',
		entering_game_short: 'Entrando no Jogo...',
		game_types: 'Tipos de Jogo',
		game_providers: 'Provedores de Jogo',
		sign_up: 'Cadastrar',
		search: 'Buscar',
		all_providers: 'Todos os Provedores',
		loading: 'Carregando...',
		my_bet: 'Minha Aposta'
	}
};